(function (Drupal, once) {
  function activateFromHash() {
    var hash = window.location.hash;
    if (!hash) {
      return;
    }
    // Only consider anchors matching a tab pane INSIDE a bloc-table.
    var pane = document.querySelector('.bloc-table .tab-pane' + hash);
    if (!pane) {
      return;
    }

    var tabId = pane.getAttribute('aria-labelledby');
    var tab = tabId ? document.getElementById(tabId) : null;
    if (tab) {
      // Bootstrap's Tab plugin will fire shown.bs.tab; we let it drive the
      // hash update so we don't write the URL twice.
      var instance = Drupal.bootstrap ? Drupal.bootstrap.Tab.getInstance(tab) : null;
      if (instance) {
        instance.show();
      } else {
        tab.click();
      }
    }

    requestAnimationFrame(function () {
      pane.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }

  function updateHashOnTabChange(root) {
    root.addEventListener('shown.bs.tab', function (event) {
      var tab = event.target;
      if (!tab.closest('.bloc-table')) {
        return;
      }
      var anchor = tab.getAttribute('data-anchor');
      var url = window.location.href.split('#')[0];
      if (anchor) {
        // Use replaceState so each tab switch doesn't pile up history entries.
        window.history.replaceState(null, '', url + '#' + anchor);
      } else if (window.location.hash) {
        // No anchor on this tab — strip any stale hash so the URL reflects state.
        window.history.replaceState(null, '', url);
      }
    });
  }

  Drupal.behaviors.ouigo_table_component = {
    attach: function attach(context) {
      once('ouigo-best-price', 'html', context).forEach(function () {
        activateFromHash();
        window.addEventListener('hashchange', activateFromHash);
      });
      once('ouigo-best-price-hash', 'html', context).forEach(function () {
        // Listen at the document level so BigPipe / AJAX re-attach doesn't
        // duplicate the listener and we don't miss panes that mount late.
        updateHashOnTabChange(document);
      });
    }
  };

  Drupal.behaviors.ouigo_table_component_nav = {
    attach: function attach(context) {
      once('panel-table-mobile-nav', '.panel-table', context).forEach(function (panelTable) {
        var tabs = Array.prototype.slice.call(panelTable.querySelectorAll('.panel-table__mobile-tab'));

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            tabs.forEach(function (otherTab) {
              otherTab.classList.remove('active');
              otherTab.setAttribute('aria-selected', 'false');
            });
            tab.classList.add('active');
            tab.setAttribute('aria-selected', 'true');
            panelTable.setAttribute('data-active-col', tab.getAttribute('data-col'));
          });
        });
      });
    }
  };
})(Drupal, once);